/* eslint-disable react/prop-types */

import { createContext } from "react";

const ReportesFinancierosContext = createContext();

export { ReportesFinancierosContext };
